import eventemitter from 'eventemitter3';
import { ElementType } from 'react';
import { logDiagnosticTrace } from '../../helpers/logDiagnosticTrace';

export class ComponentManager {
  events: eventemitter;
  mainManager: manager;
  id: number;
  state: object;

  constructor(id: number, mainManager: manager) {
    this.events = new eventemitter();

    this.id = id;
    this.mainManager = mainManager;
    this.state = {};
  }

  setState(state: object) {
    this.state = { ...this.state, ...state };

    this.events.emit('state-change', this.state);
  }

  destroy() {
    this.mainManager.removeComponent(this.id);
    logDiagnosticTrace('Phaser-react:Manager destroyed');
  }
}

class manager {
  events: eventemitter;
  lastID: number;

  constructor() {
    this.events = new eventemitter();

    this.lastID = 0;
  }

  addComponent(component: ElementType<any>, props?: object): ComponentManager {
    this.lastID++;

    const manager = new ComponentManager(this.lastID, this);
    this.events.emit('component-added', {
      mainManager: this,
      Component: component,
      manager,
      props: props || {},
    });

    return manager;
  }

  removeComponent(id: number) {
    this.events.emit('component-removed', id);
  }
}

export default new manager();
